import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  & > div {
    margin-bottom: 12px;
  }
`;
export const Title = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: GmarketSansMedium, sans-serif;
  font-size: 16px;
  padding: 8px 0;
`;
export const ListWrapper = styled.div`
  width: 100%;
  background-color: #fff;
  min-height: 96px;
`;
export const List = styled.ul`
  &:last-child > li:last-child {
    border-bottom: none;
  }
`;

export const ListItem = styled.li`
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 30px;
  border-bottom: 1px solid rgb(236, 239, 243);
  .no-data {
    display: block;
    width: 100%;
    text-align: center;
    padding: 16px 0;
    font-size: 12px;
    color: #373f4c;
    font-weight: 500;
  }
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 0;
  gap: 8px;
  max-width: 180px;

  & > img {
    width: 24px;
    height: 24px;
  }

  & > .player-back-number {
    display: block;
    width: 24px;
    min-width: 24px;
    text-align: center;
    font-size: 13px;
    font-weight: 600;
  }

  & > .player-name {
    display: block;
    flex: 1;
    font-size: 13px;
    text-align: center;
    font-weight: 600;
  }
`;
